/* global axios */
import ApiClient from './ApiClient';

class ConversationAiApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  toggleAi(conversationId, action) {
    return axios.post(`${this.url}/${conversationId}/toggle_ai`, { toggle_action: action });
  }

  getAiStatus(conversationId) {
    return axios.get(`${this.url}/${conversationId}/ai_status`);
  }
}

export default new ConversationAiApi();
